var _defs, _g, _title, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConcAvailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 410,
    viewBox: "0 0 410 410",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b656WMj1cJ",
    d: "m772.83,198.16c0,82.79 -67.21,150 -150,150c-82.78,0 -150,-67.21 -150,-150c0,-82.79 67.22,-150 150,-150c82.79,0 150,67.21 150,150z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 412,
    width: 412,
    y: -1,
    x: -1
  }))), /*#__PURE__*/React.createElement("g", null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("filter", {
    transform: "translate(0,2) translate(0,-0.15999984741210938) translate(-423,0) translate(0.170013427734375,0) ",
    primitiveUnits: "userSpaceOnUse",
    filterUnits: "userSpaceOnUse",
    height: 523,
    width: 523,
    y: -62.84,
    x: 361.83,
    id: "shadow13471891"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.07
  })), /*#__PURE__*/React.createElement("path", {
    filter: "url(#shadow13471891)",
    fill: "white",
    id: "baJqriAgh",
    d: "m350.000013,200c0,82.79 -67.21,150 -150,150c-82.78,0 -150,-67.21 -150,-150c0,-82.79 67.22,-150 150,-150c82.79,0 150,67.21 150,150z"
  })), /*#__PURE__*/React.createElement("use", {
    x: -422.829987,
    y: 1.84,
    id: "svg_4",
    fill: "#00507a",
    xlinkHref: "#b656WMj1cJ"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("use", {
    x: -422.829987,
    y: 1.84,
    id: "svg_6",
    strokeOpacity: 0.67,
    strokeWidth: 90,
    stroke: "#00507a",
    fillOpacity: 0,
    xlinkHref: "#b656WMj1cJ"
  }))))), /*#__PURE__*/React.createElement("text", {
    style: {
      cursor: "move"
    },
    fill: "#ffffff",
    strokeWidth: 0,
    x: 159,
    y: 186.37931,
    id: "svg_33",
    fontSize: 24,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    fontWeight: "bold",
    transform: "matrix(7.680335521697998,0,0,7.609161853790282,-1084.931969165802,-1151.3818813785908) ",
    stroke: "#000"
  }, "C")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcAvailable);
export default __webpack_public_path__ + "static/media/ConcAvailable.8de446b49087d695676977a9458e999a.svg";
export { ForwardRef as ReactComponent };